export default __webpack_public_path__ + "static/media/mesh-connect.7b80d42f.gif";